export default __webpack_public_path__ + "static/media/digital-store-product-07.8e7007c0.jpg";